import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { Button, Checkbox, Divider, Form, Input } from 'antd';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import IntlMessages from 'util/IntlMessages';
import { showAuthLoader, userSignIn } from 'appRedux/actions/Auth';

import styles from '../authShared.module.less';

import SocialSignIn from '../../components/SocialSignIn';
import Card from '../../components/Card';
import AppBrand from 'components/AppBrand';
import { set } from '@src/packages/utils/storage';

const SignIn = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { authUser, loader } = useSelector(({ auth }) => auth);
  const isUserIn = !!authUser;
  const disableInputs = loader || isUserIn;

  const handleFinish = values => {
    set('publicDevice', values?.publicDevice);
    dispatch(showAuthLoader());
    dispatch(userSignIn(values));
  };
  return (
    <Card
      footer={
        <div
          className={classnames(
            'gx-flex-column gx-justify-content-center gx-align-items-center gx-w-100',
            styles.footer,
          )}
        >
          <div>
            <IntlMessages id="auth.signIn.dontHaveAccount" />{' '}
            <Link className={styles.footerLink} to="/signup">
              <IntlMessages id="app.userAuth.signUp" />
            </Link>
          </div>
        </div>
      }
      className={styles.card}
    >
      <main className={styles.main} id="signin-main" aria-labelledby="app-brand-title">
        <AppBrand authHero className={styles.appBrand} titleAs="h1" />
        <SocialSignIn disabled={disableInputs} />
        <Divider className={styles.divider}>
          <IntlMessages id="auth.socialSignIn.or" />
        </Divider>
        <Form
          initialValues={{
            email: '',
            password: '',
            publicDevice: false,
          }}
          layout="vertical"
          requiredMark
          name="basic"
          onFinish={handleFinish}
          className={classnames('gx-signin-form gx-form-row0', styles.form)}
        >
          <Form.Item
            label={intl.formatMessage({ id: 'appModule.email' })}
            name="email"
            rules={[
              {
                type: 'email',
                message: intl.formatMessage({ id: 'form.format.msg' }),
              },
              { required: true, message: intl.formatMessage({ id: 'form.required.msg' }) },
            ]}
          >
            <Input autoComplete="username" disabled={disableInputs} />
          </Form.Item>
          <div className="gx-w-100 gx-mb-2">
            <Form.Item
              label={intl.formatMessage({ id: 'appModule.signIn.password' })}
              name="password"
              rules={[{ required: true, message: intl.formatMessage({ id: 'form.required.msg' }) }]}
              className="gx-mb-0"
            >
              <Input.Password autoComplete="current-password" disabled={disableInputs} />
            </Form.Item>
            <div className="gx-w-100 gx-text-right gx-mt-1">
              <Link className={classnames('gx-login-form-forgot', styles.touchLink)} to="/forgot_password">
                <IntlMessages id="app.userAuth.forgotPassword" />
              </Link>
            </div>
          </div>
          <Form.Item>
            <Button
              type="primary"
              className={classnames('gx-mb-0', styles.submitButton, isUserIn && 'gx-btn-cyan')}
              htmlType="submit"
              loading={disableInputs}
              disabled={disableInputs}
            >
              <IntlMessages id={isUserIn ? 'app.userAuth.signInDone' : 'app.userAuth.signIn'} />
            </Button>
          </Form.Item>
          <div className={styles.subpanel}>
            <Form.Item noStyle name="publicDevice" valuePropName="checked">
              <Checkbox disabled={disableInputs}>
                <IntlMessages id="auth.signIn.publicDevice" />
              </Checkbox>
            </Form.Item>
          </div>
        </Form>
      </main>
    </Card>
  );
};

export default SignIn;
